import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'
import {gu_cu_Clear} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import InputPhone from '../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import * as datos from '../../../../initital-state/facturacion.state'
import {ClienteF} from '../../../../interfaces/facturacion.interface'
import {
  actionFacturacionCliente,
  actionFacturacionProducto,
  actionGeneral,
  actionsGCAgregarCliente,
} from '../../../../actions/action-creators'
import InputChips from '../../../OtrosDocumentos/Components/InputChips'
import ModalCargarFileClientes from './ModalCargarFileClientes'
import {useHistory} from 'react-router-dom'
import {COLUMNA_DISTRITO_CLIENTES, PLANTILLAS} from '../../../../utils/cargas.utils'
import * as XLSX from 'xlsx'
import {avisoDistritoPendiente, esNormativaV2, municipioQueCorrigeElDistrito} from '../../../../utils/normativa.utils'
import {facturacionFormClienteHandleChange} from '../../../../actions/facturacion/facturacionCliente.actions'

const AgregarClienteManual = () => {
  const {tipoDocumento, departamentos, municipios, distritos, mapaDistritoMunicipio, actividadesEconomicas, datosEmisor} =
    useSelector((state: State) => state.catalogos)
  const normativaV2 = esNormativaV2(datosEmisor)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)
  const formCliente: ClienteF = useSelector((state: State) => state.facturacion.formCliente)
  const errors: ClienteF = useSelector((state: State) => state.facturacion.errorsFormCliente)
  const loader = useSelector((state: State) => state.general.loader)

  const acciones = bindActionCreators(actionFacturacionCliente, dispatch)
  const accionesProductos = bindActionCreators(actionFacturacionProducto, dispatch)
  const {getFechaHora} = bindActionCreators(actionGeneral, dispatch)
  const accionesAgregarCliente = bindActionCreators(actionsGCAgregarCliente, dispatch)

  const avisoDistrito = avisoDistritoPendiente(datosEmisor, formCliente.distrito)

  const seleccionarDistrito = (valor: any) => {
    acciones.facturacionFormClienteHandleChangeInput({target: {value: valor, name: 'distrito'}})
    acciones.facturacionFormClienteOnBlur({target: {value: valor, name: 'distrito'}})
    const municipioDerivado = municipioQueCorrigeElDistrito(
      mapaDistritoMunicipio,
      municipios,
      formCliente.departamento,
      valor,
      formCliente.municipio
    )
    if (municipioDerivado) {
      const municipioEncontrado = municipios?.find(
        (mun: any) => `${mun?.codigo ?? ''}`.trim() === municipioDerivado
      )
      dispatch(
        facturacionFormClienteHandleChange({
          municipio: municipioDerivado,
          nombreMunicipio: municipioEncontrado?.valor ?? '',
        })
      )
    }
  }

  const handleTipoDocumento = async (value: any) => {
    if (value?.value === 'sinDocumento' || value?.value === '37') {
      if (await accionesProductos.facturacionProductosVerificacionServicios())
        return setModalServicios({
          open: true,
          message: `el tipo de documento a la opción ${
            value?.value === '37' ? 'Otro' : 'Sin Documento'
          }`,
          opcion: 2,
          tipoDoc: value?.value,
        })
    }
    acciones.facturacionFormClienteHandleChangeInput({
      target: {value: value?.value, name: 'tipoDocumento'},
    })
  }

  const confirmarEliminacionServiciosDoc = () => {
    dispatch(accionesProductos.facturacionDeleteServicios())
    acciones.facturacionFormClienteHandleChangeInput({
      target: {value: modalServicios.tipoDoc, name: 'tipoDocumento'},
    })
    setModalServicios({open: false, message: '', opcion: 0, tipoDoc: '0'})
  }

  const [camposReq, setCamposReq] = useState(datos.requeridosInicial)
  const [catalogoTipoDocumento, setCatalogoTipoDocumento] = useState(tipoDocumento)
  const [catalogueActividadEconomica, setCatalogueActividadEconomica] = useState(
    actividadesEconomicas.map((tipo) => ({
      ...tipo,
      codigo_nombre: `${tipo.codigo} - ${tipo.valor}`,
    }))
  )
  const [modalServicios, setModalServicios] = useState({
    open: false,
    message: '',
    opcion: 0,
    tipoDoc: '0',
  })
  const [modalCargarFile, setModalCargarFile] = useState<boolean>(false)
  const history = useHistory()

  const RESOURCES_FOLDER = process.env.REACT_APP_RESOURCES_FOLDER
  const UTILITIES = process.env.REACT_APP_UTILITIES

  const conColumnaDistrito = async (blob: Blob): Promise<Blob> => {
    if (!normativaV2) return blob

    try {
      const libro = XLSX.read(await blob.arrayBuffer(), {type: 'array'})
      const nombreHoja = libro.SheetNames[0]
      const hoja = libro.Sheets[nombreHoja]
      if (!hoja) return blob

      const encabezados: Array<Array<any>> = XLSX.utils.sheet_to_json(hoja, {header: 1, range: 0})
      const primeraFila = (encabezados[0] ?? []).map((celda: any) => `${celda ?? ''}`.trim())
      if (primeraFila.length === 0) return blob
      if (primeraFila.some((celda) => celda === COLUMNA_DISTRITO_CLIENTES)) return blob

      const columnaMunicipio = primeraFila.findIndex((celda) => celda === 'Municipio')
      const posicion = columnaMunicipio >= 0 ? columnaMunicipio + 1 : primeraFila.length

      const filas: Array<Array<any>> = XLSX.utils.sheet_to_json(hoja, {header: 1, defval: ''})
      const filasConDistrito = filas.map((fila: Array<any>, indice: number) => {
        const copia = [...fila]
        while (copia.length < primeraFila.length) copia.push('')
        copia.splice(posicion, 0, indice === 0 ? COLUMNA_DISTRITO_CLIENTES : '')
        return copia
      })

      const libroNuevo = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(
        libroNuevo,
        XLSX.utils.aoa_to_sheet(filasConDistrito),
        nombreHoja
      )

      const bytes = XLSX.write(libroNuevo, {bookType: 'xlsx', type: 'array'})
      return new Blob([bytes], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
    } catch (error) {
      return blob
    }
  }

  const handleDescargarPlantilla = () => {
    const fileName = PLANTILLAS.CLIENTES_XLSX
    const urlPlantilla = `${UTILITIES}/${RESOURCES_FOLDER}/${fileName}?timestamp=${new Date().getTime()}`

    fetch(urlPlantilla)
      .then(response => {
        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`)
        return response.blob()
      })
      .then(conColumnaDistrito)
      .then(blob => {
        const urlDescarga = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = urlDescarga
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlDescarga)
      })
      .catch(_error => {})
  }

  const handlePrevisualizarCargaClientes = () => {
    history.push('/gestion-clientes/agregar-cliente-carga')
  }

  useEffect(() => {
    actions.gu_cu_getSucusarles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const submit = async (e: any) => {
    e.preventDefault()
    await accionesAgregarCliente.gc_ac_CreateCliente()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.facturacionFormClienteHandleChangeInput(e)
  }

  const cancelar = async () => {
    dispatch(gu_cu_Clear())
    history.push('/gestion-clientes')
  }

  return (
    <form className='card w-form w-100  mt-16' autoComplete='off' onSubmit={submit}>
      {modalCargarFile && (
        <ModalCargarFileClientes
          onAccept={handlePrevisualizarCargaClientes}
          onClose={() => setModalCargarFile(false)}
        />
      )}

      <div className='card-basic w-100'>
        <div className='mb-16'>
          <h3 className='card-title l mb-16'>Información del cliente</h3>
          <div className='separador' style={{opacity: '10%'}}></div>
          <p className='m' style={{fontWeight: '400', margin: '8px 0 0', color: '#555'}}>
            <strong>Nota:</strong> Solo los campos marcados con <span style={{color: 'red'}}>*</span>{' '}
            son obligatorios para registrar un cliente. Sin embargo, para emitir documentos como Crédito
            Fiscal (CCF) u otros que requieren información completa, deberá contar con todos los datos
            del cliente (dirección, municipio, actividad económica, etc.). Si no los agrega ahora, deberá
            completarlos al momento de emitir el documento.
          </p>
        </div>
        <div className='mt-16'>
          <div className='form-content'>
            {/*aca inicia lo de la primera fila*/}
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='tipoDocumento' className='field-label m'>
                  Tipo de documento de identificación
                  {camposReq.tipoDocumento && <span style={{color: 'red'}}>*</span>}
                </label>
                <SearchSelect
                  defaultValue={null}
                  disabled={formCliente.checkCF ? true : false}
                  placeholder='Tipo de Identificación'
                  value={formCliente.tipoDocumento}
                  name='tipoDocumento'
                  data={catalogoTipoDocumento}
                  keyNameText='valor'
                  keyNameValue='codigo'
                  onChange={(value: any) => {
                    handleTipoDocumento(value)
                  }}
                />
                {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='numId' className='field-label m'>
                  {formCliente.nombreTipoDocumento || 'Número de identificación'}
                  {camposReq.numId && <span style={{color: 'red'}}>*</span>}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='numId'
                  data-name='numId'
                  placeholder={`Número de ${formCliente.nombreTipoDocumento || 'Identificación'}`}
                  id='numId'
                  disabled={false}
                  maxLength={20}
                  value={formCliente.numId || ''}
                  onChange={handleChange}
                  onBlur={acciones.facturacionFormClienteOnBlur}
                />
                {errors.numId && <p className='alert s'>{errors.numId}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='nombre' className='field-label m'>
                  Nombre del cliente{camposReq.nombre && <span style={{color: 'red'}}>*</span>}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='nombre'
                  data-name=''
                  placeholder='Nombre del cliente'
                  id='nombre'
                  disabled={false}
                  maxLength={250}
                  value={formCliente.nombre || ''}
                  onChange={handleChange}
                  onBlur={acciones.facturacionFormClienteOnBlur}
                />
                {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
              </div>
            </div>

            {/*aca inicia lo de la segunda fila*/}
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='departamento' className='field-label m'>
                  Departamento{camposReq.departamento && <span style={{color: 'red'}}>*</span>}
                </label>
                <SearchSelect
                  defaultValue={null}
                  disabled={loader ? true : formCliente.tipoDocumento ? false : true}
                  placeholder='Departamento'
                  value={formCliente.departamento}
                  name='departamento'
                  data={departamentos?.map((dep) => ({
                    ...dep,
                    codigo_nombre: `${dep.codigo} - ${dep.valor}`,
                  }))}
                  keyNameText='codigo_nombre'
                  keyNameValue='codigo'
                  onChange={(value: any) => {
                    acciones.facturacionFormClienteHandleChangeInput({
                      target: {value: value?.value, name: 'departamento'},
                    })
                    acciones.facturacionFormClienteOnBlur({
                      target: {value: value?.value, name: 'departamento'},
                    })
                  }}
                />
                {errors.departamento && <p className='alert s'>{errors.departamento}</p>}
              </div>

              <div className='label-input'>
                <label htmlFor='municipio' className='field-label m'>
                  Municipio{camposReq.municipio && <span style={{color: 'red'}}>*</span>}
                </label>
                <SearchSelect
                  defaultValue={null}
                  disabled={
                    isNullOrEmpty(formCliente.departamento)
                      ? true
                      : formCliente.tipoDocumento
                      ? false
                      : true
                  }
                  placeholder='Municipio'
                  value={formCliente.municipio}
                  name='municipio'
                  data={municipios?.map((mun) => ({
                    ...mun,
                    codigo_nombre: `${mun?.codigo} - ${mun?.valor}`,
                  }))}
                  keyNameText='codigo_nombre'
                  keyNameValue='codigo'
                  onChange={(value: any) => {
                    acciones.facturacionFormClienteHandleChangeInput({
                      target: {value: value?.value, name: 'municipio'},
                    })
                  }}
                />
                {errors.municipio && <p className='alert s'>{errors.municipio}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='direccion' className='field-label m'>
                  Dirección{camposReq.direccion && <span style={{color: 'red'}}>*</span>}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='direccion'
                  data-name=''
                  placeholder='Dirección'
                  id='direccion'
                  disabled={
                    isNullOrEmpty(formCliente.municipio)
                      ? true
                      : formCliente.tipoDocumento
                      ? false
                      : true
                  }
                  maxLength={200}
                  value={formCliente.direccion || ''}
                  onChange={handleChange}
                  onBlur={acciones.facturacionFormClienteOnBlur}
                />
                {errors.direccion && <p className='alert s'>{errors.direccion}</p>}
              </div>
            </div>

            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='distrito' className='field-label m'>
                  Distrito
                  {normativaV2 && !isNullOrEmpty(formCliente.departamento) && (
                    <span style={{color: 'red'}}>*</span>
                  )}
                </label>
                <SearchSelect
                  defaultValue={null}
                  disabled={isNullOrEmpty(formCliente.departamento) ? true : false}
                  placeholder='Distrito'
                  value={formCliente.distrito}
                  name='distrito'
                  data={distritos?.map((dis) => ({
                    ...dis,
                    codigo_nombre: `${dis?.codigo} - ${dis?.valor}`,
                  }))}
                  keyNameText='codigo_nombre'
                  keyNameValue='codigo'
                  onChange={(value: any) => seleccionarDistrito(value?.value)}
                />
                {avisoDistrito && !errors.distrito && (
                  <p className='alert s'>{avisoDistrito}</p>
                )}
                {errors.distrito && <p className='alert s'>{errors.distrito}</p>}
              </div>
              <div className='label-input'></div>
              <div className='label-input'></div>
            </div>

            {/*aca inicia lo de la tercera fila*/}
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <InputChips
                  maxChips={5}
                  chips={formCliente.chipsEmail}
                  setChips={(chipsEmail: Array<string>) =>
                    acciones.facturacionFormClienteHandleChangeInput({
                      target: {value: chipsEmail, name: 'chipsEmail'},
                    })
                  }
                  maxLength={100}
                  onBlur={(e: any) => {
                    if (formCliente.email) acciones.facturacionFormClienteOnBlur(e)
                  }}
                  required={camposReq.email}
                  name='email'
                  placeholder='Correo electrónico'
                  label='Correo electrónico'
                  type='email'
                  value={formCliente.email}
                  error={errors.email}
                  onChange={handleChange}
                  disabled={formCliente.tipoDocumento ? false : true}
                />
              </div>
              <div className='label-input'>
                <label htmlFor='telefono' className='field-label m'>
                  Teléfono celular{camposReq.telefono && <span style={{color: 'red'}}>*</span>}
                </label>
                <InputPhone
                  disabled={formCliente.tipoDocumento ? false : true}
                  value={formCliente.telefono}
                  onChange={acciones.facturacionFormClienteHandleChangeInputPhone}
                  onBlur={acciones.facturacionFormClienteOnBlur}
                  className='telefono-style'
                  name='telefono'
                />
                {errors.telefono && <p className='alert s'>{errors.telefono}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='actividad' className='field-label m'>
                  Actividad{camposReq.actividad && <span style={{color: 'red'}}>*</span>}
                </label>
                <SearchSelect
                  defaultValue={null}
                  disabled={formCliente.tipoDocumento ? false : true}
                  placeholder='Actividad económica'
                  value={formCliente.actividad}
                  name='actividad'
                  data={catalogueActividadEconomica}
                  keyNameText='codigo_nombre'
                  keyNameValue='codigo'
                  onChange={(value: any) => {
                    acciones.facturacionFormClienteHandleChangeInput({
                      target: {value: value?.value, name: 'actividad'},
                    })
                    acciones.facturacionFormClienteOnBlur({
                      target: {value: value?.value, name: 'actividad'},
                    })
                  }}
                />
                {errors.actividad && <p className='alert s'>{errors.actividad}</p>}
              </div>
            </div>
            {/*aca inicia lo de la cuarta fila*/}
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='nrc' className='field-label m'>
                  NRC
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='nrc'
                  data-name='nrc'
                  placeholder='NRC'
                  id='nrc'
                  maxLength={7}
                  value={formCliente.nrc || ''}
                  onChange={handleChange}
                  onBlur={acciones.facturacionFormClienteOnBlur}
                />
                {errors.nrc && <p className='alert s'>{errors.nrc}</p>}
              </div>

              <div className='label-input'>
                <label htmlFor='correocc' className='field-label m'>
                  Correo CC (copia)
                </label>
                <input
                  autoComplete='off'
                  type='email'
                  className='m text-field w-input'
                  name='correocc'
                  data-name='correocc'
                  placeholder='Correo para copia (CC)'
                  id='correocc'
                  disabled={formCliente.tipoDocumento ? false : true}
                  maxLength={100}
                  value={formCliente.correocc || ''}
                  onChange={handleChange}
                />
              </div>
              <div className='label-input'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='separador mt-16'></div>
      <div
        className='mt-16 w-100 button-actions'
        style={{display: 'flex', justifyContent: 'flex-end', gap: '12px'}}
      >
        <button type='button' className='m button w-auto' onClick={handleDescargarPlantilla}>
          Descargar plantilla
        </button>
        <button type='button' className='m button w-auto' onClick={() => setModalCargarFile(true)}>
          Cargar plantilla
        </button>
      </div>

      <div
        className='mt-16 w-100 button-actions'
        style={{display: 'flex', justifyContent: 'space-between'}}
      >
        <button
          type='button'
          className='m button transparent w-inline-block w-auto'
          onClick={cancelar}
        >
          <div>Cancelar</div>
        </button>
        <button type='submit' className='m button w-inline-block w-auto'>
          <div>Agregar Cliente</div>
        </button>
      </div>
    </form>
  )
}

export default AgregarClienteManual
